import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { deleteNote, editNote, ellipsis } from '../../../../../assets/img';
import { Button, ModelTC } from '../../../../../components';
import { formatDate } from '../../../../../utils/helper';
import DropdownCategory from '../../../../Agenda/components/DropdownCategory/DropdownCategory';
import { editRemark } from '../../../redux/remarksSlice';
import styles from './remark-table-dialog.module.scss';

const mock_data_category = [
  {
    id: '1',
    name: 'Strength',
  },
  {
    id: '2',
    name: 'Development Areas',
  },
  {
    id: '3',
    name: 'Notes',
  },
  {
    id: '4',
    name: 'Development Plan',
  },
  {
    id: '5',
    name: 'Next Mobility',
  },
  {
    id: '6',
    name: 'Next 2 Mobility',
  },
  {
    id: '7',
    name: 'End State',
  },
  // {
  //   id: '8',
  //   name: 'Mobility Plan',
  // },
];

const RemarkTableBody = (props) => {
  const { item, index, length, onSaveItem, onDeleteItem, isViewModeAgenda } = props;
  const [isActive, setIsActive] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [remarkClone, setRemarkClone] = useState(item.remarks);
  const [showDelete, setShowDelete] = useState(false);

  const dispatch = useDispatch();
  const ref = useRef();

  const handleUpdate = (category) => {
    dispatch(
      editRemark({
        remarkId: item.remarkId,
        category: category?.name || '',
        remarks: remarkClone || '',
      })
    );
  };

  const handleSave = () => {
    onSaveItem({
      remarkId: item.remarkId,
      category: item.remarksCategory,
      remarks: remarkClone || '',
    });
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isActive && ref.current && !ref.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isActive]);

  return (
    <div className={styles.table_body} data-testid="item-remark-modal">
      <ModelTC
        info={{
          type: 'deleteRemarks',
          visible: showDelete,
          setVisible: setShowDelete,
          handleSubmit: () => {
            onDeleteItem(item.remarkId);
            setShowDelete(false);
          },
          onClose: () => setShowDelete(false),
        }}
      />
      <div style={{ width: '20%' }}>{item.birthName}</div>
      <div style={{ width: '15%' }}>
        {!isEdit ? (
          item.remarksCategory
        ) : (
          <DropdownCategory
            selected={item.remarksCategory}
            setSelected={(e) => handleUpdate(e)}
            options={mock_data_category}
          />
        )}
      </div>

      <div style={{ width: '15%' }}>{formatDate(item.meetingDate)}</div>
      <div style={{ width: '20%' }}>{item.meetingName}</div>

      <div style={{ width: '25%' }}>
        {!isEdit ? (
          remarkClone
        ) : (
          <div>
            <textarea
              placeholder="remark"
              className={styles.input_remark}
              value={remarkClone}
              onChange={(e) => setRemarkClone(e.target.value)}
            ></textarea>
            <div style={{ marginBottom: '22px' }} className="d-flex justify-content-end">
              <Button
                className={styles.btn_save}
                onKeyDown={() => {}}
                onClick={() => {
                  setIsEdit(false);
                  handleSave();
                }}
              >
                <span className={styles.text_btn_save}>Save</span>
              </Button>
            </div>
          </div>
        )}
      </div>
      {!isEdit && !isViewModeAgenda && (
        <div className={styles.col_1} ref={ref}>
          <img
            className={styles.ellipsis}
            src={ellipsis}
            alt="ellipsis"
            onKeyDown={() => {}}
            onClick={(e) => setIsActive(!isActive)}
            data-testid="click-to-update"
          />

          {isActive && (
            <div
              className={
                index + 1 === length
                  ? `${styles.dropdownContent} ${styles.lastItem}`
                  : styles.dropdownContent
              }
            >
              <div
                className={styles.function}
                onKeyDown={() => {}}
                onClick={() => {
                  setIsEdit(true);
                  setIsActive(false);
                }}
                data-testid="click-edit"
              >
                <img src={editNote} className={`mr-2 ${styles.editIcon}`} alt="" />
                <div className={styles.content_edit} data-testid="edit-title">
                  Edit
                </div>
              </div>

              <div
                className={styles.function}
                onKeyDown={() => {}}
                onClick={() => {
                  setIsActive(false);
                  setShowDelete(true);
                }}
                data-testid="click-delete"
              >
                <img src={deleteNote} className={`mr-2 ${styles.deleteIcon}`} alt="" />
                <div className={styles.content_delete} data-testid="delete-title">
                  Delete
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RemarkTableBody;
